module.exports = __webpack_public_path__ + "img/media-icon.32791dee.png";